export default class Animation {
  constructor (onUpdate, onComplete) {
    this.animator = null
    this.node = null
    this._time = 0
    this._duration = 60
    this._timeRatio = 0
    this._onUpdate = onUpdate
    this._onComplete = onComplete
  }

  updateIn () {
    this._time++
    this._timeRatio = this._time / this._duration
    if (this._time > this._duration) {
      this._timeRatio = 1
      this._time = this._duration
    }
  }
  updateOut () {
    if (this._onUpdate) this._onUpdate(this._timeRatio)
    if (this._time == this._duration) {
      this.dispose()
      if (this._onComplete) this._onComplete()
    }
  }
  update () {

  }
  /*
  updateDEMO () {
    updateIn()



    updateOut()
  }*/
  dispose () {
    this.node.list.removeNode(this.node)
  }
}